'use client';

import { c as _c } from "react/compiler-runtime";
import { Collapsible, CollapsibleContent, Item } from '@repo/ui/components';
import { LucideIcon } from '@repo/ui/icons';
import { cn } from '@repo/ui/lib/utils';
import { AnimatePresence } from '@repo/ui/motion';
import { PropsWithChildren, type ReactNode, useState } from 'react';
import { DetailsItemActions, type DetailsItemActionsProp } from './details-item-actions.tsx';
import { DetailsItemHeader, type DetailsItemSource } from './details-item-header.tsx';
import { MotionCollapsibleContent } from './details-item-motion-content.tsx';
export const DetailsItem = t0 => {
  const $ = _c(34);
  const {
    actions,
    children,
    className,
    collapsible: t1,
    defaultOpen: t2,
    Icon,
    menuTitle,
    needsWarning: t3,
    source,
    title
  } = t0;
  const collapsible = t1 === undefined ? false : t1;
  const defaultOpen = t2 === undefined ? true : t2;
  const needsWarning = t3 === undefined ? false : t3;
  const [open, setOpen] = useState(defaultOpen);
  let t4;
  if ($[0] !== className) {
    t4 = cn(className);
    $[0] = className;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== collapsible) {
    t5 = open_0 => {
      if (collapsible) {
        setOpen(open_0);
      }
    };
    $[2] = collapsible;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = collapsible ? open : true;
  let t7;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = cn("flex! flex-col items-start gap-4");
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = cn("flex w-full min-w-0 items-center gap-2");
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== Icon || $[7] !== collapsible || $[8] !== needsWarning || $[9] !== open || $[10] !== source || $[11] !== title) {
    t9 = <DetailsItemHeader collapsible={collapsible} Icon={Icon} needsWarning={needsWarning} open={open} source={source} title={title} data-sentry-element="DetailsItemHeader" data-sentry-source-file="details-item.tsx" />;
    $[6] = Icon;
    $[7] = collapsible;
    $[8] = needsWarning;
    $[9] = open;
    $[10] = source;
    $[11] = title;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== actions || $[14] !== menuTitle) {
    t10 = actions && <DetailsItemActions actions={actions} menuTitle={menuTitle} />;
    $[13] = actions;
    $[14] = menuTitle;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <div className={t8}>{t9}{t10}</div>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== children || $[20] !== collapsible || $[21] !== defaultOpen || $[22] !== open) {
    t12 = collapsible ? open && <MotionCollapsibleContent initial={defaultOpen ? "visible" : "hidden"}>{children}</MotionCollapsibleContent> : <CollapsibleContent className="w-full">{children}</CollapsibleContent>;
    $[19] = children;
    $[20] = collapsible;
    $[21] = defaultOpen;
    $[22] = open;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12) {
    t13 = <AnimatePresence data-sentry-element="AnimatePresence" data-sentry-source-file="details-item.tsx">{t12}</AnimatePresence>;
    $[24] = t12;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t11 || $[27] !== t13) {
    t14 = <Item className={t7} variant="outline" data-sentry-element="Item" data-sentry-source-file="details-item.tsx">{t11}{t13}</Item>;
    $[26] = t11;
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== t14 || $[30] !== t4 || $[31] !== t5 || $[32] !== t6) {
    t15 = <Collapsible className={t4} onOpenChange={t5} open={t6} data-sentry-element="Collapsible" data-sentry-component="DetailsItem" data-sentry-source-file="details-item.tsx">{t14}</Collapsible>;
    $[29] = t14;
    $[30] = t4;
    $[31] = t5;
    $[32] = t6;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  return t15;
};